module.exports = __webpack_public_path__ + "../resources/img/ic_refresh_mobile_light.56619212.svg";